module.exports = __webpack_public_path__ + "static/media/bg_login.3edd720e.jpg";